





























































import { computed, defineComponent, SetupContext } from '@vue/composition-api';
import { find } from 'lodash';
import { useGroups } from '@/store/modules/group';
import { getGroupTree } from '@/store/modules/group/utils';
import { useMemberships } from '@/store/modules/memberships';
import { useUser } from '@/store/modules/user';
import { Group } from '@/store/types';
import Breadcrumbs from '@/views/group/Breadcrumbs.vue';
import GroupListRow from '@/views/group/GroupListRow.vue';
import MembershipDeleteButton from '@/views/group/MembershipDeleteButton.vue';

export default defineComponent({
	components: { MembershipDeleteButton, Breadcrumbs, GroupListRow },
	props: {
		id: { type: String, required: true },
	},
	setup(props, { root }: SetupContext) {
		const {
			isLoading: membershipsAreLoading,
			isLoaded: membershipsAreLoaded,
			hasError: membershipsHaveError,
			memberships,
		} = useMemberships(root.$store, props.id);
		const {
			isLoading: groupsAreLoading,
			isLoaded: groupsAreLoaded,
			hasError: groupsHaveError,
			groups,
			groupTree,
		} = useGroups(root.$store);
		const { isLoading: userIsLoading, hasError: userHasError, user } = useUser(root.$store);
		const group = computed<Group | undefined>(() => groups.value.find((g) => g.id === props.id));
		const childGroups = computed<Group[]>(() => getGroupTree(groups.value, undefined, group.value));

		const addMember = () => {
			root.$router.push(`/groups/${group.value?.id}/membership/new/`);
		};

		const addGroup = () => {
			root.$router.push(`/groups/${group.value?.id}/new`);
		};

		return {
			groups,
			group,
			groupTree,
			find,
			memberships,
			groupsAreLoading,
			groupsAreLoaded,
			groupsHaveError,
			membershipsAreLoading,
			membershipsAreLoaded,
			membershipsHaveError,
			childGroups,
			addMember,
			addGroup,
			user,
			userIsLoading,
			userHasError,
		};
	},
});
